import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { Changelog } from '@/features/settings/Changelog';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings/changelog',
  component: Changelog,
});
